<template>
  <v-container class="home">
    <v-row class="my-2">
      <v-col>
        <v-sheet outlined style="text-align: center" class="crane-border-green">
          <v-row>
            <v-col><h2 class="mt-5">Lectures</h2></v-col>
          </v-row>
          <v-simple-table class="ma-3" style="text-align: left;">
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Topic</th>
                  <th>Reading</th>
                  <th>Downloads</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in lectures" :key="item.date">
                  <td>{{ item.date }}</td>
                  <td>{{ item.topic }}</td>
                  <td>{{ item.reading }}</td>
                  <td>
                    <a v-if="item.slides" :href="item.slides" target="_blank" >Slides</a>
                    <span v-else>Slides</span>
                    &nbsp;
                    <a v-if="item.notes" :href="item.notes" target="_blank">Notes</a>
                    <span v-else>Notes</span>
                    &nbsp;
                    <a v-if="item.lecture" :href="item.lecture" target="_blank">Lecture</a>
                    <span v-else>Lecture</span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data: () => ({
    lectures: [
      {
        date: "Jan 26",
        topic: "1. Intro. to CS167 and OS",
        reading: "Sections 1.1 and 1.2",
        slides: "content/lectures/01Intro.pdf",
        notes: "content/lectures/01IntroX.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=d363bfce-eeea-4db0-95f1-ae230156ed76",
      },
      {
        date: "Jan 28",
        topic: "2. Threads Implementations",
        reading: "Section 5.1",
        slides: "content/lectures/02ThreadsImp.pdf",
        notes: "content/lectures/02ThreadsImpX.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=38edf6ab-e84d-489e-af0f-ae230156edbc",
      },
      {
        date: "Jan 31",
        topic: "3. Threads Implementations",
        reading: "",
        slides: "content/lectures/03ThreadsImp2.pdf",
        notes: "content/lectures/03ThreadsImp2X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=d17e1046-8869-4dda-a06e-ae230156eddb",
      },
      {
        date: "Feb 2",
        topic: "4. Threads Implementations",
        reading: "",
        slides: "content/lectures/04ThreadsImp3.pdf",
        notes: "content/lectures/04ThreadsImp3X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=34921fee-b629-4968-bdc5-ae230156edfa",
      },
      {
        date: "Feb 4",
        topic: "5. Interrupts",
        reading: "Chapter 3, Section 5.2",
        slides: "content/lectures/05ThreadsImp4.pdf",
        notes: "content/lectures/05ThreadsImp4X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=75a1d296-ae04-402c-b1ff-ae230156ee2a",
      },
      {
        date: "Feb 7",
        topic: "6. I/O and Booting",
        reading: "",
        slides: "content/lectures/06Interrupts.pdf",
        notes: "content/lectures/06InterruptsX.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=f5dd164c-0ca1-4288-84ba-ae230156ee49",
      },
      {
        date: "Feb 9",
        topic: "7. Introduction to UnixTM and Weenix OS Structure",
        reading: "Section 4.1",
        slides: "content/lectures/07IO.pdf",
        notes: "content/lectures/07IOX.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=87909bd8-a18d-43d3-a813-ae230156ee6c",
      },
      {
        date: "Feb 11",
        topic: "8. Introduction to UnixTM and Weenix OS Structure",
        reading: "",
        slides: "content/lectures/08UnixStructure.pdf",
        notes: "content/lectures/08UnixStructureX.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=86d35d0c-dbf0-4243-8a0f-ae230156ee89",
      },
      {
        date: "Feb 14",
        topic: "9. OS Design: Virtual Machines",
        reading: "Section 4.2.1",
        slides: "content/lectures/09UnixStructure.pdf",
        notes: "content/lectures/09UnixStructureX.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=d16b3546-6d1b-4f0c-97d2-ae230156eea7",
      },
      {
        date: "Feb 16",
        topic: "10. OS Design: Virtual Machines",
        reading: "",
        slides: "content/lectures/10VirtMach1.pdf",
        notes: "content/lectures/10VirtMach1X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=67188e45-4fde-4749-a7a5-ae230156eec3",
      },
      {
        date: "Feb 18",
        topic: "11. OS Design: Microkernels",
        reading: "Section 4.2.2",
				slides: "content/lectures/11VirtMach2.pdf",
        notes: "content/lectures/11VirtMach2X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=491a8c14-4144-4234-80c7-ae230156eef1",
      },
      {
        date: "Feb 23",
        topic: "12. Scheduling",
        reading: "Section 5.3",
        slides: "content/lectures/12MicroKernel.pdf",
        notes: "content/lectures/12MicroKernelX.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=05992efd-965c-4148-814a-ae230156ef31",
      },
      {
        date: "Feb 25",
        topic: "13. Scheduling",
        reading: "",
        slides: "content/lectures/13Sched.pdf",
        notes: "content/lectures/13SchedX.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=401106f6-40e2-429e-8164-acd2014e0a81",
      },
      {
        date: "Feb 28",
        topic: "14. Scheduling",
        reading: "",
        slides: "content/lectures/14Sched2.pdf",
        notes: "content/lectures/14Sched2X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=fe9bda9f-6a60-4cf4-85dc-ae230156ef74",
      },
      {
        date: "Mar 2",
        topic: "15. File Systems",
        reading: "Chapter 7",
        slides: "content/lectures/15File1.pdf",
        notes: "content/lectures/15File1X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=491647dc-07c8-4228-9a7e-ae230156ef97",
      },
      {
        date: "Mar 4",
        topic: "16. File Systems",
        reading: "",
        slides: "content/lectures/16File2.pdf",
        notes: "content/lectures/16File2X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=54845655-7c1a-4028-8e29-ae230156efc9",
      },
      {
        date: "Mar 7",
        topic: "17. File Systems",
        reading: "",
        slides: "content/lectures/17File3.pdf",
        notes: "content/lectures/17File3X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=e9793231-9cfa-431f-9461-ae230156efff",
      },
      {
        date: "Mar 9",
        topic: "18. File Systems",
        reading: "",
        slides: "content/lectures/18File4.pdf",
        notes: "content/lectures/18File4X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=7ecbacff-9aff-4e94-872f-ae230156f02b",
      },
      {
        date: "Mar 11",
        topic: "19. File Systems",
        reading: "",
        slides: "content/lectures/19File5.pdf",
        notes: "content/lectures/19File5X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=006af821-78fa-45d4-89bc-ae230156f048",
      },
      {
        date: "Mar 14",
        topic: "20. File Systems",
        reading: "",
        slides: "content/lectures/20File6.pdf",
        notes: "content/lectures/20File6X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=4383deb1-5476-4a6c-b64c-ae230156f068",
      },
      {
        date: "Mar 16",
        topic: "21. Virtual Memory: Architecture",
        reading: "Sections 6.1, 6.2",
        slides: "content/lectures/21File7.pdf",
        notes: "content/lectures/21File7X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=bc61c358-f445-4911-a8ca-ae230156f086",
      },
      {
        date: "Mar 18",
        topic: "22. Virtual Memory: OS",
        reading: "Section 6.3",
        slides: "content/lectures/22File8.pdf",
        notes: "content/lectures/22File8X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=edb603fa-2e92-4c57-8981-ae230156f0a6",
      },
      {
        date: "Mar 21",
        topic: "23. Virtual Memory: OS",
        reading: "",
        slides: "content/lectures/23VM1.pdf",
        notes: "content/lectures/23VM1X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=290f6492-a385-49b1-92cf-ae230156f122",
      },
      {
        date: "Mar 23",
        topic: "24. Virtual Memory: OS",
        reading: "",
        slides: "content/lectures/24VM2.pdf",
        notes: "content/lectures/24VM2X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=1ffc233f-7b2d-4239-b3a0-ae230156f143",
      },
      {
        date: "Mar 25",
        topic: "25. Weenix Review",
        reading: "",
        slides: "content/lectures/25VM3.pdf",
        notes: "content/lectures/25VM3X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=f672589b-4358-450c-b498-ae230156f16a",
      },
      {
        date: "Apr 4",
        topic: "26. Security",
        reading: "Chapter 10",
        slides: "content/lectures/26VM4.pdf",
        notes: "content/lectures/26VM4X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=b2b197e9-695f-490a-8fbd-ae230156f20c",
      },
      {
        date: "Apr 6",
        topic: "27. Security",
        reading: "",
        slides: "content/lectures/27Security2.pdf",
        notes: "content/lectures/27Security2X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=cee770a9-599c-4249-aca1-ae230156f22c",
      },
      {
        date: "Apr 8",
        topic: "28. Security",
        reading: "Section 8.1",
        slides: "content/lectures/28Security3.pdf",
        notes: "content/lectures/28Security3X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=bb8a67c9-96a7-49c0-b48b-ae230156f24c",
      },
      {
        date: "Apr 11",
        topic: "29. Security",
        reading: "",
        slides: "content/lectures/29Security4.pdf",
        notes: "content/lectures/29Security4X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=e46773de-525b-44ac-8a0a-ae230156f26a",
      },
      {
        date: "Apr 13",
        topic: "30. Communication Protocols",
        reading: "Section 8.2",
        slides: "content/lectures/30Security5.pdf",
        notes: "content/lectures/30Security5X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=0a81e9cb-6a5f-42f6-8bf1-ae230156f28a",
      },
      {
        date: "Apr 15",
        topic: "31. Remote Procedure Call Protocols",
        reading: "Section 8.2",
        slides: "content/lectures/31Security6.pdf",
        notes: "content/lectures/31Security6X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=93e6ea35-02e4-4bfc-bda7-ae230156f2a8",
      },
      {
        date: "Apr 18",
        topic: "32. Distributed File Systems",
        reading: "Chapter 9",
        slides: "content/lectures/32Network.pdf",
        notes: "content/lectures/32NetworkX.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=d09e90ce-72f3-43ed-94d8-ae230156f2cc",
      },
      {
        date: "Apr 20",
        topic: "33. Distributed File Systems",
        reading: "",
        slides: "content/lectures/33RPC.pdf",
        notes: "content/lectures/33RPCX.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=c50b9261-8f2b-45e7-aa6f-ae230156f2ec",
      },
      {
        date: "Apr 22",
        topic: "34. Distributed File Systems",
        reading: "",
        slides: "content/lectures/34DFS1.pdf",
        notes: "content/lectures/34DFS1X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=1851b6e0-ce96-4cd5-9eba-ae230156f30c",
      },
      {
        date: "Apr 25",
        topic: "35. Avoiding Operating Systems",
        reading: "",
        slides: "content/lectures/35DFS2.pdf",
        notes: "content/lectures/35DFS2X.pdf",
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=d09019a2-9133-43de-8759-ae230156f32a",
      },      
      {
        date: "Apr 27",
        topic: "36. Summing Up",
        reading: "",
        slides: "content/lectures/36Fini.pdf",
        notes: "content/lectures/36FiniX.pdf", 
        lecture: "https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=5cf10c91-6338-41bc-b914-ae230156f347",
      },
    ],
  }),
};
</script>
<style scoped>

@import '../styles/crane.css';

.profile {
  width: 250px;
  margin: auto;
}

.profile img {
  width: 200px;
  height: 200px;
  object-fit: cover;
}
</style>
